import firebase from 'firebase/app'
import 'firebase/functions';
import config from '@/config'

var fbApp = firebase.initializeApp(config.firebase[process.env.APP_CONF.instance])
//fbApp.functions().useFunctionsEmulator('http://localhost:5000');
